export const PHYSICAL_LOCATION_TYPE = 'physical';
export const GEOGRAPHICAL_LOCATION_TYPE = 'geographical';
